// Former private betas that are now generally available. A key listed here
// passes every beta gate (server `hasBetaAccess`/`requireBetaAccess`, client
// `useBetaAccess`) for every signed-in account, without per-user grants, so
// promoting a beta to GA is a one-line change that leaves the gate code and
// any existing grants in place.
//
//   owner_portal   — Travis, Oct 3, 2026 (backend plan D28): open to everybody.
//   quo_messaging  — Travis, Oct 3, 2026 (backend plan D22): Quo is a built-in
//                    feature (Messages → Settings → Messaging provider), not a beta.
export const GENERALLY_AVAILABLE_BETA_KEYS: readonly string[] = ["owner_portal", "quo_messaging", "member_cleaning"];

export function isGenerallyAvailableBeta(key: string): boolean {
  return GENERALLY_AVAILABLE_BETA_KEYS.includes(key);
}
